"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignableDocumentQuery = exports.SignableDocumentUpdate = exports.SignableDocumentCreate = exports.SignableDocumentTransport = exports.SignableDocumentTypeLabels = exports.SignableDocumentType = exports.SignableDocumentTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
exports.SignableDocumentTypes = ['SERVICE_AGREEMENT', 'LAWN_WAIVER', 'LIEN_RELEASE'];
exports.SignableDocumentType = typebox_1.Type.Union(exports.SignableDocumentTypes.map((type) => typebox_1.Type.Literal(type)));
exports.SignableDocumentTypeLabels = {
    SERVICE_AGREEMENT: 'Service Agreement',
    LAWN_WAIVER: 'Lawn Waiver',
    LIEN_RELEASE: 'Lien Release',
};
exports.SignableDocumentTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    type: exports.SignableDocumentType,
    name: typebox_1.Type.String(),
    s3ItemRef: common_1.S3ItemReference,
    expiresAt: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    metadata: common_1.MetaData,
});
exports.SignableDocumentCreate = typebox_1.Type.Omit(exports.SignableDocumentTransport, ['id', 'expiresAt', 'metadata']);
exports.SignableDocumentUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.SignableDocumentCreate, ['s3ItemRef']),
    typebox_1.Type.Object({
        shouldExpire: typebox_1.Type.Boolean(),
    }),
]));
exports.SignableDocumentQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        type: exports.SignableDocumentType,
        name: typebox_1.Type.String(),
        isActive: typebox_1.Type.Boolean(),
    }),
]));
//# sourceMappingURL=signable-document-transport.js.map